import React from "react";
import { connect } from "react-redux";

import Toolbar from "./toolbar";
import { useIntl, defineMessages } from "react-intl";

import { labourerFieldList } from "./labourersFieldList";
import DataList from "../common/dataList/dataList";
import "./labourers.css";

const messages = defineMessages({
    labourerSettingsPageTitle: {
        id: "labourer-settings.title",
        defaultMessage: "Manage Labourers",
        description: "Labourer Settings page title",
    },
});

/*
    Table to represent the list of labourers
    props:
        - labourers: array, list of labourers
*/

export const Labourers = ({ labourers }) => {
    const intl = useIntl();

    return (
        <>
            <Toolbar title={intl.formatMessage(messages.labourerSettingsPageTitle)} />
            <div
                style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "white",
                }}>
                <DataList rows={labourers} fields={labourerFieldList} dragging={false} />
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    labourers: state.technicians,
});

export default connect(mapStateToProps)(Labourers);
